import { render, staticRenderFns } from "./Button3.vue?vue&type=template&id=75419908&scoped=true&"
import script from "./Button3.vue?vue&type=script&lang=js&"
export * from "./Button3.vue?vue&type=script&lang=js&"
import style0 from "./Button3.vue?vue&type=style&index=0&id=75419908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75419908",
  null
  
)

export default component.exports